import React from "react";
// react component that copies the given text inside your clipboard
// reactstrap components
import {Container,} from "reactstrap";
import ManageUsersList from "../../../components/ManageUsers/ManageUsersList";
import {TableFiltersProvider} from "../../../context/table_filters/TableFiltersIndex";
// core components

const ManageUsersView = () => {
  return (
    <>
      <Container fluid className="mt-5">
        <TableFiltersProvider>
          <ManageUsersList
          />
        </TableFiltersProvider>
      </Container>
    </>
  );
};

export default ManageUsersView;
